import {
  SIGNIN_REQUEST,
  SIGNIN_SUCCESS,
  SIGNIN_FAILURE,
  REFRESH_SUCCESS,
  LOGOUT,
} from "store/modules/auth/actions/actions.types";

export interface AuthState {
  accessToken: string | null;
  refreshToken: string | null;
  loading: boolean;
  error: string | null;
  expireIn: string | null;
}

const INITIAL_STATE: AuthState = {
  accessToken: null,
  refreshToken: null,
  loading: false,
  error: null,
  expireIn: null,
};

export default function authReducer(
  state = INITIAL_STATE,
  action: any,
): AuthState {
  switch (action.type) {
    case SIGNIN_REQUEST:
      return { ...state, loading: true, error: null };

    case SIGNIN_SUCCESS:
      return {
        ...state,
        loading: false,
        accessToken: action.payload.accessToken,
        refreshToken: action.payload.refreshToken,
        expireIn: action.payload.expireIn,
      };

    case REFRESH_SUCCESS:
      return {
        ...state,
        loading: false,
        accessToken: action.payload.accessToken,
        refreshToken: action.payload.refreshToken,
        expireIn: action.payload.expireIn,
      };

    case SIGNIN_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case LOGOUT:
      return { ...INITIAL_STATE };

    default:
      return state;
  }
}
